var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3l2 .667m0 0l-2 6a3.334 3.334 0 004 0l-2-6zm0 0l2 6m-2-6l4-1.334m0 0l4 1.334M7 2.333V1m0 1.333V13m4-9.332L13 3m-2 .667l-2 6a3.334 3.334 0 004 0l-2-6zm-4 9.332H5m2 0h2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/balance.9de30941.svg";
export { SvgBalance as ReactComponent };